import { useFormContext } from "react-hook-form";
import { EditableTableCell } from "react-migration/components/EditableTableCell";
import {
  UpdateLetterBatchInput,
  UpdateLetterBatchesTableResponseData,
} from "react-migration/domains/sites/typings";
import { LandTechEndpoints, routedClient, useTranslation } from "react-migration/lib";

import { useMutation } from "@apollo/client";

import UPDATE_LETTER_BATCH from "../../../apollo/letters-api/mutations/updateLetterBatch.gql";
import { LetterBatchesTableRecordFormData } from "./LetterBatchesTableRecordSchema";

export interface LetterBatchesTableRecordFormProps {
  rowIndex: number;
}

const getFormId = (idx: number) => "letterBatchesTableRecordForm_" + idx;

export const LetterBatchesTableRecordForm = ({ rowIndex }: LetterBatchesTableRecordFormProps) => {
  const { t } = useTranslation();

  const methods = useFormContext<LetterBatchesTableRecordFormData>();

  const {
    handleSubmit,
    formState: { errors, isDirty, dirtyFields },
    resetField,
    register,
  } = methods;

  const [updateLetterBatch] = useMutation<
    UpdateLetterBatchesTableResponseData,
    UpdateLetterBatchInput
  >(UPDATE_LETTER_BATCH, {
    client: routedClient,
    context: {
      endpoint: LandTechEndpoints.Letters,
    },
  });

  const onFormSubmit = handleSubmit(({ id, name }) => {
    if (isDirty && dirtyFields?.name) {
      updateLetterBatch({
        variables: {
          letterBatchInput: { id, name },
        },
      });
    }
  });

  const error = errors?.name?.message;

  return (
    <form onSubmit={onFormSubmit} id={getFormId(rowIndex)} data-testid="letter-batches-table-form">
      <EditableTableCell
        data-testid={`name-input-${rowIndex}`}
        label={t("sites.letter_batches.name")}
        error={error ? t(error) : undefined}
        onEscPressed={() => {
          resetField(`name`);
        }}
        submit={onFormSubmit}
        {...register(`name`)}
      />
    </form>
  );
};
